import { render, staticRenderFns } from "./CommentsItem.vue?vue&type=template&id=1369f3b0&"
import script from "./CommentsItem.vue?vue&type=script&lang=ts&"
export * from "./CommentsItem.vue?vue&type=script&lang=ts&"
import style0 from "./CommentsItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports